import React, { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './LiveFeedSection.css';

const LiveFeedSection: React.FC = () => {
  const { t } = useTranslation();

  // Referencia al CONTENEDOR (Div), no a la imagen
  const videoWrapperRef = useRef<HTMLDivElement | null>(null);
  const textRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (videoWrapperRef.current) observer.observe(videoWrapperRef.current);
    if (textRef.current) observer.observe(textRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <>
    <section className="live-feed-section">
      <div className="live-feed-container">

        <div className="video-column">
          {/* El Wrapper controla la animación de entrada */}
          <div
            className="video-wrapper"
            ref={videoWrapperRef}
          >
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/BQk-afuAEh8?si=3fxqrq6Bz4Qv25kK"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="video-iframe"
            ></iframe>
          </div>
        </div>

        <div className="text-column" ref={textRef}>
          <h2 className="live-feed-title">
            <Trans i18nKey="livefeed:title" />
          </h2>

          <p className="live-feed-description">
            <Trans i18nKey="livefeed:description" />
          </p>

          <p className="live-feed-cta">
            <Trans
              i18nKey="livefeed:cta"
              components={{
                strong: <strong />,
                em: <em />
              }}
            />
          </p>
        </div>

      </div>
    </section>
    </>
  );
};

export default LiveFeedSection;